import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../HomePage/Navbar';
import './AuthPages.css';

import Footer from '../HomePage/Footer';

const defaultIntro = (
  <>
    <img src="/img/neuratrader_logo.png" alt="NeuraTrader" className="auth-page-logo" />
    <h1 className="auth-page-title">NeuraTrader</h1>
    <p className="auth-page-subtitle">
      Automate your crypto trading with intelligent bots, real-time monitoring, and professional-grade tools.
    </p>
    <ul className="auth-page-features">
      <li>
        <span className="auth-page-feature-dot" aria-hidden="true" />
        Set up grid, scheduled, and algorithmic bots in minutes
      </li>
      <li>
        <span className="auth-page-feature-dot" aria-hidden="true" />
        Monitor orders, wallets, and strategies from one dashboard
      </li>
      <li>
        <span className="auth-page-feature-dot" aria-hidden="true" />
        Built for spot and futures markets
      </li>
    </ul>
  </>
);

/**
 * props:
 * - title
 * - description
 * - children
 * - footer
 * - intro
 * - withSiteFooter
 */
function AuthLayout(props) {
  return (
    <main className="auth-page">
      <Navbar />
      <section className="auth-page-content">
        <div className="auth-page-grid">
          <div className="auth-page-intro">
            {props.intro || defaultIntro}
          </div>

          <div className="auth-card">
            <Link to="/" className="auth-back-link">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
              </svg>
              Back to homepage
            </Link>

            <div className="auth-card-header">
              <h2 className="auth-card-title">{props.title}</h2>
              {props.description && (
                <p className="auth-card-description">{props.description}</p>
              )}
            </div>

            {props.children}

            {props.footer && (
              <div className="auth-footer-text">{props.footer}</div>
            )}
          </div>
        </div>
      </section>
      {props.withSiteFooter && <Footer />}
    </main>
  );
}

export default AuthLayout;